const options = require('../src/config/options')
const isServerSide = require('./modules/is-server-side')
const envApiPrefix = require('./modules/env-api-prefix')

const config = {
  restUrl: (path, version) => {
    version = version ? version : 'v1'
    let host = options.Api.host

    if (envApiPrefix() && isServerSide()) {
      host = envApiPrefix()
    }

    if (!isServerSide()) {
      if (
        typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement &&
        window.athesia_react &&
        window.athesia_react.app_env &&
        window.athesia_react.app_env.length > 0 &&
        process.env.RAZZLE_ENVIRONMENT === 'staging'
      ) {
        let hostSelection = window.athesia_react.app_env === 'live' ? `https://www.stol.it` : `https://re.stol.it`
        host = `${hostSelection}/api/rest/`
      }
    }

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + version + '/' + path
  },
  baseUrl: (path) => {
    const host = '/'

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
  authUrl: (path) => {
    const host = options.User.authUrl

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
  geoUrl: (path) => {
    let host = options.Geo.host

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
}

module.exports = config
